export interface Item {
  id: number;
  company_id: number;
  type: 'PRODUCTO' | 'SERVICIO';
  code?: string;
  name: string;
  description?: string;
  price: number;
  cost_price: number;
  tax_rate: number;
  active: boolean;
  created_at: string | Date;
  updated_at: string | Date;
}

export interface ItemCreateData {
  type: 'PRODUCTO' | 'SERVICIO';
  code?: string;
  name: string;
  description?: string;
  price: number;
  cost_price: number;
  tax_rate: number;
  active?: boolean;
}

export interface ItemUpdateData extends Partial<ItemCreateData> {}

export interface ItemFilters {
  search: string;
  type: string;
  active: string | boolean;
}

export interface ItemsResponse {
  items: Item[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface ItemStats {
  total: number;
  active: number;
  inactive: number;
  productos: number;
  servicios: number;
}

export const ITEM_TYPES = [
  { value: 'PRODUCTO', label: 'Producto' },
  { value: 'SERVICIO', label: 'Servicio' }
] as const;

export type ItemType = typeof ITEM_TYPES[number]['value'];